import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	address__type__list: 'mw/address/type/list',
};

export const addressApi = createApi({
	reducerPath: 'mw/addressApi',

	endpoints: (builder) => ({
		addressTypeList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/address/type/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.address__type__list],
		}),
	}),
});

export const {
	addressTypeList,
} = addressApi.endpoints;

export default addressApi;